import React, { useState, useEffect, useRef } from 'react';
import { getAllProducts } from '../utils/productService';
import { useNavigate, Link } from 'react-router-dom';
import PixoryHomeProductCard from '../components/Products/PixoryHomeProductCard';
import Header from '../components/Header';
import SiteFooter from '../components/SiteFooter';
import './Home.css';
import './Photobooks.css';
import './FooterStuhia.css';
import wall01 from '../assets/images/wall01.jpg';
import wall02 from '../assets/images/wall02.jpg';
import wall03 from '../assets/images/wall03.jpg';
import wallpaperBook from '../assets/images/wallpaperBook.png';
import '@fortawesome/fontawesome-free/css/all.min.css';
import iconArrow from '../assets/figma-home/icon-arrow.svg';
import iconArrow2 from '../assets/figma-home/icon-arrow2.svg';
import bannerCiaoItalia from '../assets/figma-home/banner-ciao-italia.png';
import bannerUneUdhetim from '../assets/figma-home/banner-une-udhetim.png';
import bannerBonjurFrance from '../assets/figma-home/banner-bonjur-france.png';
import bannerBigParis from '../assets/figma-home/banner-big-paris.png';
import { IconPhotos, IconDesign, IconUpload, IconLayout, IconSend, IconConfirm } from '../components/icons/StepIcons';
import { IconHardcover, IconGiftBox } from '../components/icons/FeatureIcons';
import { useLanguage } from '../context/LanguageContext';

const steps = [
  { Icon: IconPhotos, label: 'Zgjedh fotot' },
  { Icon: IconDesign, label: 'Zgjedh dizajnin' },
  { Icon: IconUpload, label: 'Ngrakoj Fotot' },
  { Icon: IconLayout, label: 'Krijo radhitjen' },
  { Icon: IconSend, label: 'Dorzo Porosin' },
  { Icon: IconConfirm, label: 'Prit Konfirmimin' },
];

// Homepage "Albumet" rows: one row per category, capped at 5 products, each
// followed by a "see all" link into the filtered catalog. Labels live in
// src/i18n/*.js under cat.* — the same keys drive the per-card series label
// (CSS lowercases it on the card).
const HOME_CATEGORY_ROWS = ['travel', 'wedding', 'baby', 'kitchen', 'agenda', 'kids'];

// "Njihu me markën" accordion — tekstet te src/i18n/*.js nën home.storyN*.
const BRAND_STORY = [
  { titleKey: 'home.story1Title', textKey: 'home.story1Text' },
  { titleKey: 'home.story2Title', textKey: 'home.story2Text' },
  { titleKey: 'home.story3Title', textKey: 'home.story3Text' },
  { titleKey: 'home.story4Title', textKey: 'home.story4Text' },
];

// Testimonials are built and styled but kept off until real reviews are
// supplied — flip the flag and fill the array rather than showing placeholders.
const SHOW_TESTIMONIALS = false;
const TESTIMONIALS = []; // [{ quote, author }]

// Galeria "fletaime + ju" — fotot më poshtë janë VENDMBAJTËSE nga asetet e
// projektit; zëvendësoji me foto reale të klientëve (importe lokale ose URL).
// Seksioni fshihet vetiu nëse array-i zbrazet.
const CUSTOMER_GALLERY_PHOTOS = [
  { src: wall01, alt: 'Fotolibër i hapur në duar' },
  { src: wall02, alt: 'Fotolibra Fletaime' },
  { src: wall03, alt: 'Fotolibër i personalizuar' },
  { src: wallpaperBook, alt: 'Album Fletaime i hapur' },
];

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const navigate = useNavigate();
  const { t } = useLanguage();

  // Cili element i accordion-it "njihu me markën" është i hapur (-1 = asnjë)
  const [openStory, setOpenStory] = useState(0);

  // Horizontal-scroll product rows (3 large cards visible, arrows scroll the rest)
  const rowRefs = useRef({});
  const scrollRow = (id, dir) => {
    const el = rowRefs.current[id];
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' });
  };

  useEffect(() => {
    getAllProducts()
      .then(setProducts)
      .finally(() => setLoadingProducts(false));
  }, []);
  const categories = [
    { id: 'all', name: 'Të Gjitha Produktet', icon: '' },
    { id: 'wedding', name: 'Love Book', icon: '' },
    { id: 'travel', name: 'Travel Book', icon: '' },
    { id: 'baby', name: 'Baby Book', icon: '' },
    { id: 'agenda', name: 'Agjenda 2026', icon: '' },
    { id: 'kitchen', name: 'Ditari i Kuzhinës', icon: '' },
    { id: 'kids', name: 'Kids Book', icon: '' },
    { id: 'frame', name: 'Kornizë Muri', icon: '' },
  ];

  const isPersonalizo = (p) => /personalizo|kopertin/i.test(p.name);

  const NEW_PRODUCTS_CUTOFF = new Date('2026-05-01T00:00:00.000Z');
  const isNewProduct = (p) => p.createdAt && new Date(p.createdAt) > NEW_PRODUCTS_CUTOFF;

  const discountedProducts = products
    .filter(p => p.originalPrice && p.originalPrice > p.price)
    .slice(0, 4);

  const personalizoProduct = products.find(isPersonalizo);

  const handleCategoryChange = (categoryId) => {
    navigate(categoryId === 'all' ? '/photobooks' : `/photobooks?cat=${categoryId}`);
  };

  return (
    <div className="home-page">
      <Header />

      {/* Mobile Categories Bar
      <div className="mobile-categories-bar">
        {categories.map(category => (
          <button
            key={category.id}
            className="mobile-category-btn"
            onClick={() => handleCategoryChange(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div> */}

      {/* Hero — washed flat-lay photo behind centered copy */}
      <section className="pixory-hero">
        <img className="pixory-hero-photo" src={wall02} alt="" aria-hidden="true" />
        <div className="pixory-hero-content">
          {/* <h1 className="pixory-hero-title">kujtimet tuaja,<br />përgjithmonë të ruajtura</h1> */}
          <p className="pixory-hero-subtitle">{t('home.heroSubtitle')}</p>
          <button className="pixory-hero-btn" onClick={() => navigate('/product/124')}>
            {t('home.orderNow')}
          </button>
        </div>
      </section>

      {/* Category banners
      <section className="figma-banners">
        <div className="figma-banners-left">
          <div className="figma-banner-wide">
            <div className="figma-banner-wide-img-wrap">
              <img src={bannerCiaoItalia} alt="Ciao Italia" />
            </div>
            <div className="figma-banner-wide-text">
              <p className="figma-banner-wide-title">CIAO ITALIA</p>
              <p className="figma-banner-wide-desc">Rrugëtimet italiane meritojnë më shumë se një galeri telefoni - kthejini në një fotolibër që mbahet në duar.</p>
            </div>
          </div>
          <div className="figma-banners-squares">
            <div className="figma-banner-square light">
              <div className="figma-banner-square-img-wrap">
                <img src={bannerUneUdhetim} alt="Një Udhëtim Një Kujtim" />
              </div>
              <div className="figma-banner-square-text">
                <p className="figma-banner-square-title">NJË UDHËTIM<br /><span>NJË KUJTIM</span></p>
                <p className="figma-banner-square-desc">Çdo destinacion, një faqe e re në albumin tënd.</p>
              </div>
            </div>
            <div className="figma-banner-square dark">
              <div className="figma-banner-square-img-wrap">
                <img src={bannerBonjurFrance} alt="Bonjur France" className="mirrored" />
              </div>
              <div className="figma-banner-square-text">
                <p className="figma-banner-square-title">BONJUR<br />FRANCE!</p>
                <p className="figma-banner-square-desc">Kujtimet nga Franca, të printuara bukur.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="figma-banner-big">
          <img src={bannerBigParis} alt="Paris" className="figma-banner-big-img" />
        </div>
      </section> */}

      {/* Cilësia e produktit
      <section className="figma-features">
        <div className="figma-feature-card figma-feature-card-photo">
          <div className="figma-feature-photo-wrap">
            <img src={wall01} alt="Fotolibër i printuar, i hapur në duar" />
          </div>
          <p className="figma-feature-title">Printuar me kujdes</p>
          <p className="figma-feature-desc">Çka shihni është çka printojmë — foto të qarta dhe ngjyra të sakta, në letër premium.</p>
        </div>
        <div className="figma-feature-card">
          <IconHardcover className="figma-feature-icon" />
          <p className="figma-feature-title">Kopertinë e fortë</p>
          <p className="figma-feature-desc">Krijuar për t'u mbajtur gjatë — kopertinë e fortë që mbron kujtimet tuaja për vite me radhë.</p>
        </div>
        <div className="figma-feature-card">
          <IconGiftBox className="figma-feature-icon" />
          <p className="figma-feature-title">Gati për t'u dhuruar</p>
          <p className="figma-feature-desc">I paketuar me kujdes, gati të mbërrijë tek ju ose tek dikush i veçantë.</p>
        </div>
      </section> */}

      {/* Cilësia e produktit — kokë gri (titull + përshkrim) mbi foto të madhe.
          Fotot janë vendmbajtëse nga asetet ekzistuese; ndërro src-të kur të
          kesh fotografitë reale. */}
    

      {/* Si funksionon
      <section className="figma-steps">
        <div className="figma-steps-top">
          <p className="figma-steps-title">Si funksionon ?</p>
          <div className="figma-steps-arrows">
            <button className="figma-steps-arrow" aria-label="Prapa"><img src={iconArrow} alt="" /></button>
            <button className="figma-steps-arrow rotated" aria-label="Para"><img src={iconArrow2} alt="" /></button>
          </div>
        </div>
        <div className="figma-steps-row">
          {steps.map((step) => (
            <div key={step.label} className="figma-step-card">
              <step.Icon className="figma-step-icon" />
              <p className="figma-step-label">{step.label}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* Albumet, sipas kategorive — ndërkohë sa presim produktet, mbajmë një
          placeholder me lartësi të përafërt, në vend që seksioni të mos
          ekzistojë fare, që "Njihu me markën" më poshtë të mos "hidhet"
          papritur kur produktet mbërrijnë dhe seksioni i vërtetë futet mbi të. */}
      {loadingProducts ? (
        <section className="figma-products-section" aria-hidden="true">
          {[0, 1].map((rowIdx) => (
            <div key={rowIdx} className="figma-category-row">
              <div className="figma-category-row-head">
                <div className="skeleton-block skeleton-row-title" />
              </div>
              <div className="pixory-card-grid">
                {[0, 1, 2].map((cardIdx) => (
                  <div key={cardIdx} className="skeleton-block skeleton-card" />
                ))}
              </div>
            </div>
          ))}
        </section>
      ) : (
        <section className="figma-products-section">
          {HOME_CATEGORY_ROWS.map((rowId) => {
            const rowProducts = products.filter((p) => p.category === rowId).slice(0, 5);
            if (rowProducts.length === 0) return null;
            return (
              <div key={rowId} className="figma-category-row">
                <div className="figma-category-row-head">
                  <p className="figma-category-row-title">{t(`cat.${rowId}`)}</p>
                  <div className="pixory-row-arrows">
                    <button type="button" aria-label={t('home.rowPrev')} onClick={() => scrollRow(rowId, -1)}>
                      <img src={iconArrow} alt="" />
                    </button>
                    <button type="button" className="rotated" aria-label={t('home.rowNext')} onClick={() => scrollRow(rowId, 1)}>
                      <img src={iconArrow2} alt="" />
                    </button>
                  </div>
                </div>
                <div className="pixory-card-grid" ref={(el) => { rowRefs.current[rowId] = el; }}>
                  {rowProducts.map((product) => (
                    <PixoryHomeProductCard
                      key={product.id}
                      product={product}
                      isNew={isNewProduct(product)}
                      label={t(`cat.${product.category}`)}
                    />
                  ))}
                </div>
                <Link to={`/photobooks?cat=${rowId}`} className="figma-row-see-all">
                  {t('home.seeAllModels')}
                </Link>
              </div>
            );
          })}
        </section>
      )}

      {/* 4-up category banner strip */}

      {/* <section className="figma-strip">
        <div
          className="figma-strip-item white"
          onClick={() => products.find(p => p.id === 494) && navigate(`/product/494`)}
        >
          <div className="figma-strip-text">
            <p className="figma-strip-title">Travel Book</p>
            <p className="figma-strip-desc">Kujtime nga çdo qytet që ke vizituar, në një album unik.</p>
            <button className="figma-strip-btn">Shiko Tani</button>
          </div>
        </div>
        <div
          className="figma-strip-item gray"
          onClick={() => products.find(p => p.id === 454) && navigate(`/product/454`)}
        >
          <div className="figma-strip-text">
            <p className="figma-strip-title">Wedding Book</p>
            <p className="figma-strip-desc">Dita e dasmës, e ruajtur me stil dhe elegancë.</p>
            <button className="figma-strip-btn">Shiko Tani</button>
          </div>
        </div>
        <div
          className="figma-strip-item white"
          onClick={() => products.find(p => p.id === 474) && navigate(`/product/474`)}
        >
          <div className="figma-strip-text">
            <p className="figma-strip-title">Baby Book</p>
            <p className="figma-strip-desc">Rritja e fëmijës tuaj, moment pas momenti.</p>
            <button className="figma-strip-btn">Shiko Tani</button>
          </div>
        </div>
        <div
          className="figma-strip-item dark"
          onClick={() => personalizoProduct && navigate(`/product/${personalizoProduct.id}`)}
        >
          <div className="figma-strip-text">
            <p className="figma-strip-title dark">Personalizo</p>
            <p className="figma-strip-desc dark">Kopertinë krejt e jotja, sipas idesë tënde.</p>
            <button className="figma-strip-btn dark">Shiko Tani</button>
          </div>
        </div>
      </section> */}
  {/* <section className="figma-features">
        <div className="figma-feature-card">
          <div className="figma-feature-head">
            <p className="figma-feature-title">printuar me kujdes</p>
            <p className="figma-feature-desc">Çka shihni është çka printojmë — foto të qarta dhe ngjyra të sakta, në letër premium.</p>
          </div>
          <div className="figma-feature-photo">
            <img src={wall01} alt="Fotolibër i printuar, i hapur në duar" />
          </div>
        </div>
        <div className="figma-feature-card">
          <div className="figma-feature-head">
            <p className="figma-feature-title">kopertinë e fortë</p>
            <p className="figma-feature-desc">Krijuar për t'u mbajtur gjatë — kopertinë e fortë që mbron kujtimet tuaja për vite me radhë.</p>
          </div>
          <div className="figma-feature-photo">
            <img src={wallpaperBook} alt="Album Fletaime me kopertinë të fortë, i hapur" />
          </div>
        </div>
        <div className="figma-feature-card">
          <div className="figma-feature-head">
            <p className="figma-feature-title">gati për t'u dhuruar</p>
            <p className="figma-feature-desc">I paketuar me kujdes, gati të mbërrijë tek ju ose tek dikush i veçantë.</p>
          </div>
          <div className="figma-feature-photo">
            <img src={wall03} alt="Fotolibër i personalizuar si dhuratë" />
          </div>
        </div>
      </section> */}

      {/* Njihu me markën — foto majtas (vendmbajtëse, ndërroje src-në),
          djathtas titulli + accordion. Tekstet redaktohen te BRAND_STORY. */}
      <section className="figma-brand-section">
        <div className="figma-brand-photo">
          <img src={wall02} alt="Fotolibra Fletaime" />
        </div>
        <div className="figma-brand-content">
          <div>
            <p className="figma-brand-title">{t('home.brandTitle')}</p>
            <p className="figma-brand-sub">{t('home.brandSub')}</p>
          </div>
          <div className="figma-brand-accordion">
            {BRAND_STORY.map((item, i) => (
              <div key={item.titleKey} className="figma-brand-item">
                <button
                  type="button"
                  className="figma-brand-item-head"
                  onClick={() => setOpenStory(openStory === i ? -1 : i)}
                >
                  <span>{t(item.titleKey)}</span>
                  <svg
                    className={`figma-brand-chevron ${openStory === i ? 'open' : ''}`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>
                {openStory === i && <p className="figma-brand-item-text">{t(item.textKey)}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Discounts
      {discountedProducts.length > 0 && (
        <section className="figma-discounts-section">
          <p className="figma-discounts-title">Zbritje deri në -30%</p>
          <div className="pixory-card-grid">
            {discountedProducts.map((product) => (
              <PixoryHomeProductCard
                key={product.id}
                product={product}
                isNew={isNewProduct(product)}
                label={CATEGORY_LABELS[product.category]}
              />
            ))}
          </div>
        </section>
      )} */}

      {SHOW_TESTIMONIALS && TESTIMONIALS.length > 0 && (
        <section className="figma-testimonials-section">
          <p className="figma-testimonials-title">{t('home.testimonialsTitle')}</p>
          <div className="figma-testimonials-grid">
            {TESTIMONIALS.map((item, i) => (
              <div key={i} className="figma-testimonial-card">
                <p className="figma-testimonial-quote">&ldquo;{item.quote}&rdquo;</p>
                <p className="figma-testimonial-author">{item.author}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* fletaime + ju — galeria e fotove (vendmbajtëse, ndërroji te
          CUSTOMER_GALLERY_PHOTOS në krye të skedarit) */}
      {CUSTOMER_GALLERY_PHOTOS.length > 0 && (
        <section className="figma-gallery-section">
          <p className="figma-gallery-title">{t('home.galleryTitle')}</p>
          <p className="figma-gallery-sub">{t('home.gallerySub')}</p>
          <div className="figma-gallery-grid">
            {CUSTOMER_GALLERY_PHOTOS.map((photo, i) => (
              <div key={i} className="figma-gallery-item">
                <img src={photo.src} alt={photo.alt || ''} loading="lazy" />
              </div>
            ))}
          </div>
          <a
            className="figma-gallery-social-btn"
            href="https://www.instagram.com/fletaime/?hl=en"
            target="_blank"
            rel="noreferrer"
          >
            {t('home.gallerySocial')}
          </a>
        </section>
      )}

      {/* Nevojë për ndihmë */}
      <section className="figma-help-section">
        <p className="figma-help-title">{t('home.helpTitle')}</p>
        <p className="figma-help-desc">{t('home.helpDesc')}</p>
        <div className="figma-help-actions">
          <a href="https://wa.me/38345937644" target="_blank" rel="noreferrer" className="figma-help-btn">
            WhatsApp
          </a>
          <a href="mailto:fletaimecom@gmail.com" className="figma-help-btn outline">
            fletaimecom@gmail.com
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default Home;
